import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchPayments = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Validate and sanitize parameters
    const validatedPage = Math.max(1, parseInt(page) || 1);
    const validatedPerPage = Math.max(1, Math.min(100, parseInt(per_page) || 10));

    // Prepare base params object
    const params = {
      page: validatedPage,
      per_page: validatedPerPage
    };

    // Add filters - simplified and more reliable approach
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params[key] = filters[key];
      }
    });

    console.log('Final API params:', params); // Debug log

    // Make the request
    const response = await axios.get(`${BASE_URL_BE}/payment/transaksi`, {
      headers: getAuthHeaders(),
      params: params,
      paramsSerializer: {
        indexes: null
      }
    });

    // Validate response structure
    if (!response.data) {
      throw new Error('Invalid API response: missing data');
    }

    return {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      meta: {
        page: response.data.meta?.page || validatedPage,
        per_page: response.data.meta?.per_page || validatedPerPage,
        total: response.data.meta?.total || 0,
        last_page: response.data.meta?.last_page || 1
      }
    };

  } catch (error) {
    console.error("Error fetching produk:", error);
    
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'Failed to fetch produk data';
    
    const apiError = new Error(errorMessage);
    apiError.status = error.response?.status;
    apiError.details = error.response?.data?.errors || {};
    
    throw apiError;
  }
};

export const fetchPaymentsByStatus = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Validate and sanitize parameters
    const validatedPage = Math.max(1, parseInt(page) || 1);
    const validatedPerPage = Math.max(1, Math.min(100, parseInt(per_page) || 10));

    // Prepare base params object
    const params = {
      page: validatedPage,
      per_page: validatedPerPage
    };

    // Add filters - simplified and more reliable approach
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params[key] = filters[key];
      }
    });

    console.log('Final API params:', params); // Debug log

    // Make the request
    const response = await axios.get(`${BASE_URL_BE}/payment/status`, {
      headers: getAuthHeaders(),
      params: params,
      paramsSerializer: {
        indexes: null
      }
    });

    // Validate response structure
    if (!response.data) {
      throw new Error('Invalid API response: missing data');
    }

    return {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      meta: {
        page: response.data.meta?.page || validatedPage,
        per_page: response.data.meta?.per_page || validatedPerPage,
        total: response.data.meta?.total || 0,
        last_page: response.data.meta?.last_page || 1
      }
    };

  } catch (error) {
    console.error("Error fetching produk:", error);
    
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'Failed to fetch produk data';
    
    const apiError = new Error(errorMessage);
    apiError.status = error.response?.status;
    apiError.details = error.response?.data?.errors || {};
    
    throw apiError;
  }
};
